import { createApiRef } from '@backstage/frontend-plugin-api';
import { DefaultApiResponse } from '@internal/backstage-plugin-devops-react';

export const providersApiRef = createApiRef<ProvidersApi>().with({
  id: 'providers-api',
  pluginId: 'catalog-devops',
});

export interface ProvidersApi {
  triggerProvider(providerType: string): Promise<DefaultApiResponse>;
}
